<template>
  <div>
    <div class="search">
      <div class="left">
        <el-input
          v-model.trim="search.keyword"
          placeholder="请输入编号/内容"
          clearable
          class="input"
        />
        <el-select
          v-model="search.dimension"
          class="ml"
          placeholder="选择维度"
          clearable
        >
          <el-option
            v-for="(v, i) in optionDimensionList"
            :key="i"
            :label="v.name"
            :value="v.value"
          />
        </el-select>
        <el-select
          v-model="search.status"
          class="ml"
          placeholder="选择状态"
          clearable
        >
          <el-option
            v-for="(v, i) in optionStatusList"
            :key="i"
            :label="v.name"
            :value="v.value"
          />
        </el-select>
        <el-button
          type="primary"
          plain
          class="ml"
          @click="handleSearch"
        >
          查询
        </el-button>
      </div>
      <div class="right">
        <el-button
          type="primary"
          plain
          @click="handleDialogOpen"
        >
          新建
        </el-button>
      </div>
    </div>

    <div class="data">
      <el-table
        :data="list"
        border
      >
        <el-table-column
          v-for="(c, i) in column"
          :key="i"
          :label="c.label"
          :prop="c.prop"
        >
          <div slot-scope="scope">
            <template v-if="c.prop === 'dimension'">{{ scope.row.dimension | filterDimension }}</template>
            <template v-else-if="c.prop === 'status'">
              <el-button
                v-if="scope.row.status === '0'"
                plain
              >
                失效
              </el-button>
              <el-button
                v-else
                type="success"
                plain
              >
                {{ scope.row.status | filterStatus }}
              </el-button>
            </template>
            <template v-else-if="c.prop === 'owner_name'">
              <span v-if="scope.row.owner_name">{{ scope.row.owner_name }}</span>
              <span v-else>-</span>
            </template>
            <template v-else>
              {{ scope.row[c.prop] }}
            </template>

            <template v-if="c.prop === 'opt'">
              <el-button
                type="text"
                @click="handleCtrlEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlCancel(scope.row)"
              >
                {{ scope.row.status === '0' ? '置为有效' : '置为失效' }}
              </el-button>
              <el-button
                type="text"
                @click="handleCtrlLogOpen(scope.row)"
              >
                日志
              </el-button>
            </template>
          </div>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleChangePage"
        />
      </div>
    </div>

    <!-- 新建 & 编辑 -->
    <el-dialog
      :visible.sync="detailVisible"
      :title="form.id ? '编辑' : '添加'"
      width="600px"
      class="dialog"
    >
      <el-form label-width="120px">
        <!-- <el-form-item label="聚合预算">
          <el-input
            v-model="form.budget_name"
            placeholder="输入聚合预算名称"
            class="input"
          />
        </el-form-item> -->
        <el-form-item
          label="聚合预算"
          prop="budget_name"
        >
          <el-select
            v-model="form.budget_name"
            filterable
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="输入并选择聚合预算"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 91%"
            @change="onBudgetChange"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.budget_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="销售名称">
          <span>{{ form.owner_name || '-' }}</span>
        </el-form-item>
        <el-form-item label="维度">
          <el-select
            v-model="form.dimension"
            placeholder="请选择维度"
            clearable
          >
            <el-option
              v-for="(item, i) in optionDimensionList"
              :key="i"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model="form.content"
            placeholder="输入对应维度匹配的内容"
            class="input"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="detailVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleDialogConfirm"
        >
          确定
        </el-button>
      </span>
    </el-dialog>

    <!--日志-->
    <el-dialog
      title="日志"
      :visible.sync="logVisible"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
const req = new Request();
let self;
export default {
  name: 'aggregation-budget',

  filters: {
    filterDimension(v) {
      return self.optionDimensionList.filter((f) => f.value === Number(v))[0]
        .name;
    },
    filterStatus(v) {
      return self.optionStatusList.filter((f) => f.value === Number(v))[0].name;
    },
  },
  data() {
    return {
      optionDimensionList: [
        { name: '子代理名称', value: 1 },
        { name: '快应用公司名称', value: 2 },
        { name: '代理商公司名称', value: 3 },
      ],
      optionStatusList: [
        { name: '有效', value: 1 },
        { name: '失效', value: 0 },
      ],

      search: {
        keyword: '',
        dimension: '',
        status: '',
      },

      column: [
        { label: '编号', prop: 'id' },
        { label: '聚合预算', prop: 'budget_name' },
        { label: '销售名称', prop: 'owner_name' },
        { label: '维度', prop: 'dimension' },
        { label: '内容', prop: 'content' },
        { label: '状态', prop: 'status' },
        { label: '操作', prop: 'opt' },
      ],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,

      detailVisible: false,
      form: {
        id: '',
        budget_name: '',
        dimension: '',
        content: '',
        owner_name: '',
        budget_id: '',
      },

      logVisible: false,
      logId: '',
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,

      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
    };
  },

  mounted() {
    self = this;
    this.init();
  },

  methods: {
    // 输入并选择聚合预算下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.budgetBind.list, {
            keyword: key,
            page: this.page,
            page_size: 10000000000,
            status: 1,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.list || [];
      } catch (err) {
        this.$message.error(`获取聚合预算失败：${err.message || '未知错误'}`);
      }
    },
    // 聚合预算与销售名称实现联动
    onBudgetChange(value) {
      const selectedOption = this.editProdSalorDlg.options.find(
        (option) => option.id === value,
      );
      if (selectedOption) {
        this.form.budget_name = selectedOption.budget_name;
        this.form.owner_name = selectedOption.owner_name;
        this.form.budget_id = parseInt(selectedOption.id);
      }
    },
    init() {
      this.getList();
    },

    // 搜索
    handleSearch() {
      this.page = 1;
      this.getList();
    },

    async getList() {
      try {
        const { data } = await req.send(req.Apis.customer.budget.list, {
          keyword: this.search.keyword,
          dimension: this.search.dimension,
          status: this.search.status,
          page: this.page,
          page_size: this.pageSize,
        });
        this.list = data.list || [];
        this.total = Number(data.total);
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleChangePage(n) {
      this.page = n;
      this.getList();
    },

    // 操作按钮: 编辑
    handleCtrlEdit(row) {
      this.form = {
        id: parseInt(row.id),
        budget_name: row.budget_name,
        dimension: parseInt(row.dimension),
        content: row.content,
        owner_name: row.owner_name || '-', // 如果有销售名称则显示，否则显示 "-"
        budget_id: parseInt(row.budget_id),
      };
      this.detailVisible = true;
    },

    // 操作按钮: 失效&有效
    handleCtrlCancel(row) {
      this.$confirm('确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await req.send(req.Apis.customer.budget.review, { id: row.id });
          this.$message.success('操作成功');
          this.getList();
        } catch (err) {}
      });
    },

    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budget.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 1,
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },

    // dialog: open
    handleDialogOpen() {
      this.detailVisible = true;
      this.form = {
        id: '',
        budget_name: '',
        dimension: '',
        content: '',
        owner_name: '-', // 初始化销售名称
        budget_id: '',
      };
    },

    // dialog: 添加&编辑
    async handleDialogConfirm() {
      let params = {
        budget_name: this.form.budget_name,
        dimension: this.form.dimension,
        content: this.form.content,
        owner_name: this.form.owner_name, // 添加销售名称到参数中
        budget_id: this.form.budget_id,
      };
      let api = req.Apis.customer.budget.add;

      if (!this.form.budget_name) {
        this.$message.error('请输入聚合预算名');
        return;
      }
      if (!this.form.dimension) {
        this.$message.error('请选择维度');
        return;
      }
      if (!this.form.content) {
        this.$message.error('请输入对应维度匹配的内容');
        return;
      }

      // 编辑
      if (this.form.id) {
        params['id'] = this.form.id;
        api = req.Apis.customer.budget.update;
      }

      try {
        await req.send(api, params);
        this.$message.success('操作成功');
        this.getList();
      } catch (err) {}
      this.detailVisible = false;
    },
  },
};
</script>

<style lang="less">
.search {
  display: flex;
  justify-content: space-between;
  & .ml {
    margin-left: 15px;
  }
  & .left {
    & .input {
      width: 300px;
    }
  }
  & .right {
  }
}

.data {
  margin-top: 20px;
  & .page {
    margin-top: 20px;
    text-align: right;
  }
}

.dialog {
  & .input {
    width: 400px;
  }
}
</style>
